@for (item of links; track item.id) {
  <div class="discover-more-link" (click)="open(item)">{{ item.name }}</div>
}
